import { DownloadIcon } from 'lucide-react';
import { ComponentProps, useMemo } from 'react';

import type { MediaViewerFile } from '@/components/features/media/MediaViewer';

import { Button } from '@/components/ui/button';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { AudioPlayer } from '@/components/ui/media-player';
import { getFileUrl } from '@/utils/file/getFileUrl';

export default function MediaAudioViewer(mediaViewerFile: MediaViewerFile) {
  const { file, open, onOpenChange } = mediaViewerFile;
  const isFilesInstance: boolean = 'id' in file;

  const fileURL = useMemo<string>(() => {
    if ('id' in file) {
      return getFileUrl(file.id);
    } else if (file instanceof File) {
      return URL.createObjectURL(file);
    }
    return '';
  }, [file]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={'sm:max-w-xl'}>
        <DialogBody>
          <DialogHeader>
            <DialogTitle>{file.name}</DialogTitle>
            <DialogDescription className={'sr-only'}>{file.name} - podgląd</DialogDescription>
          </DialogHeader>
          <div className={'flex h-full w-full grow flex-col p-4'}>
            <MediaAudioViewerContent src={fileURL} />
          </div>
        </DialogBody>
        <DialogFooter>
          {isFilesInstance ? (
            <a href={fileURL} download target="_self">
              <Button variant={'ghost'}>
                <DownloadIcon />
              </Button>
            </a>
          ) : null}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function MediaAudioViewerContent(mediaAudioViewerContentProps: ComponentProps<typeof AudioPlayer>) {
  const { src, ...props } = mediaAudioViewerContentProps;

  return <AudioPlayer src={src} {...props} />;
}
